<canvas class="chart-container" #sentimentCanvas></canvas>
